export const inFav = (recipe_id, favRecipesArr) => {
    for (let i = 0; i < favRecipesArr?.length; i++) {
        if (recipe_id === favRecipesArr[i]) {
            return true;
        }
    }
    return false;
}

 // name validation check, only able to use letters
 export const name = (e) => {
    const re = /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/;
    if (!re.test(e.key)) {
        e.preventDefault();
    }
}

// phone validation check, key pressed when entering telephone number can only be numbers
export const phone = (e) => {
    const re = /[0-9]+/g;
    if (!re.test(e.key) || e.target.value.length > 11) {
        e?.preventDefault();
    }
}

// telnum formatting
export const telnum = (e, tel, setTel) => {
    let val = e.target.value;
    if ((tel.length === 2 && val.length === 3) || (tel.length === 6 && val.length === 7)) {
        val += '-';
    }
    else if ((tel.length === 4 && val.length === 3) || (tel.length === 8 && val.length === 7)) {
        val = val.slice(0, -1);
    }
    setTel(val);
}

// Helper function to normalize various date formats to integer timestamp (milliseconds)
export const normalizeTimestamp = (dateInput) => {
    // If already an integer timestamp, return as-is
    if (typeof dateInput === 'number') {
        return dateInput;
    }
    
    // Handle Firebase Timestamp objects (Firestore v9)
    if (dateInput && typeof dateInput === 'object') {
        // Check if it's a Firebase Timestamp with toMillis method
        if (typeof dateInput.toMillis === 'function') {
            return dateInput.toMillis();
        }
        // Check if it's a JavaScript Date object
        if (dateInput instanceof Date || typeof dateInput.getTime === 'function') {
            return dateInput.getTime();
        }
        // Check if it's a Firebase Timestamp with seconds property (legacy format)
        if (dateInput.seconds !== undefined) {
            return dateInput.seconds * 1000; // Convert seconds to milliseconds
        }
    }
    
    // Handle string dates
    if (typeof dateInput === 'string') {
        const parsed = Date.parse(dateInput);
        if (!isNaN(parsed)) {
            return parsed;
        }
    }
    
    // Fallback: try to create a Date object
    try {
        const date = new Date(dateInput);
        if (!isNaN(date.getTime())) {
            return date.getTime();
        }
    } catch (e) {
        // If all else fails, return the input (may cause errors downstream)
        console.warn('Unable to normalize date input:', dateInput);
        return dateInput;
    }
    
    return dateInput;
}

export const getDateString = timestamp => {
    // Normalize the timestamp to handle Firebase Timestamps and other formats
    const normalizedTimestamp = normalizeTimestamp(timestamp);
    let date = new Date(normalizedTimestamp);
    let month = date.getMonth() + 1;
    let day = date.getDate();
    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;
    let str = date.getFullYear() + "-" + month + "-" + day;
    return str;
  }


export const calculateWeekEndDate = (datestring) => {
    let date = new Date();
    let args = datestring.split("-");
    date.setFullYear(parseInt(args[0]));
    date.setMonth(parseInt(args[1]) - 1);
    date.setDate(parseInt(args[2]) + 7 - 1);
    return date.getTime();
  }

export const calculateWeekStartDate = (datestring) => {
  let date = new Date();
  let args = datestring.split("-");
  date.setFullYear(parseInt(args[0]));
  date.setMonth(parseInt(args[1]) - 1);
  date.setDate(parseInt(args[2]) + 7);
  return date.getTime();
}  

export const getWeeksArray = (start_date, numberOfWeeks) => {
    // Normalize the start_date to handle Firebase Timestamps and other formats
    const normalizedStartDate = normalizeTimestamp(start_date);
    
    let weekDateArr = [];
    let arr = [];
    const weeks = numberOfWeeks;
        for(let i = 0; i < weeks; i++) {
          arr.push((i + 1));
        }


    let weekStartDate = getDateString(normalizedStartDate);
    for(let i = 0; i < arr.length; i++) { //get week no and weekstartdate and weekendate in array
        let weekDates = {
        week:  i + 1,
        weekStartDate: weekStartDate,
        weekEndDate: getDateString(calculateWeekEndDate(weekStartDate))
        }
        weekStartDate = getDateString(calculateWeekStartDate(weekStartDate))

        weekDateArr.push(weekDates);
    }

    return weekDateArr
}

export const getUpdatedWeekArray = (weeklyRecipes, weekDateArr) => {

    let result = weeklyRecipes.reduce((results, item) => {
        results[item.week] = results[item.week] || [];
        results[item.week].push(item.recipes);
    
        return results;
    }, {});

    weeklyRecipes = Object.keys(result).map(function (key) {
        return {week: key, recipes: result[key]};
    });

    return weeklyRecipes.map((item) => {
        weekDateArr.map(({week, weekStartDate, weekEndDate}) => {
            if(week === Number(item.week)) {
                   item.weekStartDate =  weekStartDate;
                   item.weekEndDate = weekEndDate;
            }
        });
        return  item
    }); 

}

// Helper function to get recipe week from new array structure
export const getRecipeWeek = (programRecipes, recipeId) => {
    if (!programRecipes || !Array.isArray(programRecipes)) return null;
    const recipe = programRecipes.find(r => r.recipeId === recipeId);
    return recipe ? recipe.week : null;
}

// Helper function to get user's program start date (joinedAt or fallback to programStartDate)
export const getUserProgramStartDate = (program, userId) => {
    return program?.programUsers?.[userId]?.joinedAt || program?.programStartDate;
}

// Image format detection helpers
export const isFullUrl = (imagePath) => {
    if (!imagePath || typeof imagePath !== 'string') return false;
    return imagePath.startsWith('http://') || imagePath.startsWith('https://');
}

export const isBase64 = (imagePath) => {
    if (!imagePath || typeof imagePath !== 'string') return false;
    return imagePath.startsWith('data:image/');
}

export const isRelativeUrl = (imagePath) => {
    if (!imagePath || typeof imagePath !== 'string') return false;
    return imagePath.startsWith('/');
}

export const isFirebaseFilename = (imagePath) => {
    if (!imagePath || typeof imagePath !== 'string') return false;
    // If it's not a full URL, base64, or relative URL, assume it's a Firebase filename
    return !isFullUrl(imagePath) && !isBase64(imagePath) && !isRelativeUrl(imagePath);
}